import { render, staticRenderFns } from "./StoreCurrency.vue?vue&type=template&id=1044e881&"
import script from "./StoreCurrency.vue?vue&type=script&lang=ts&"
export * from "./StoreCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports